/**
 * Resolve a manifest-relative URL against a stations.json base URL.
 * Supports absolute bases, root-relative paths (/converter-output/...), and
 * page-relative paths.
 */
export function resolveRelativeUrl(base: string, relative: string): string {
  const absoluteBase =
    base.startsWith('/') || (!base.includes('://') && !base.startsWith('http'))
      ? new URL(base, window.location.origin).href
      : base;
  return new URL(relative, absoluteBase).href;
}
